import { setLeadingCapital } from '~/cynqueModules/utils/setLeadingCapital'
import { useEntityDialogStore } from '~/stores/entityDialog'

export async function logAndSetStoreValue({
  fn,
  storePropertyName,
  value,
}: {
  fn: string
  storePropertyName: string
  value: any
}) {
  console.debug(`${fn}  Setting ${storePropertyName} to: ${value}`)
  await useEntityDialogStore()[`set${setLeadingCapital(storePropertyName)}`](
    value
  )
}
